import {SitesConfirmDialogComponent} from '../components/dumb/sites-confirm-dialog/sites-confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Injectable} from '@angular/core';
import {IProductDataAddonModifyMenu} from '../types/product.type';
import {DeleteSiteDialogComponent} from '../components/dumb/delete-site-dialog/delete-site-dialog.component';
import {ForbiddenAccessDialogComponent} from '../components/dumb/forbidden-access-dialog/forbidden-access-dialog.component';
import {ManageGroupConfirmDialogComponent} from '../components/dumb/manage-group-confirm-dialog/manage-group-confirm-dialog.component';

@Injectable({providedIn: 'root'})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  openDialog(onConfirmCallback: () => void, data?: {modifyMenuSites: IProductDataAddonModifyMenu['modifyMenuSites']}) {
    const dialogRef = this.dialog.open(SitesConfirmDialogComponent, {
      width: '610px',
      data,
    });
    dialogRef.afterClosed().subscribe((result: {confirm: boolean}) => {
      if (result?.confirm) {
        onConfirmCallback();
      }
    });
  }

  openDeleteDialog(onConfirmCallback: () => void, data: {siteUrl: string; isSiteHaveSubscription?: boolean}) {
    const dialogRef = this.dialog.open(DeleteSiteDialogComponent, {
      width: '610px',
      data,
    });
    dialogRef.afterClosed().subscribe((result: {confirm: boolean}) => {
      if (result?.confirm) {
        onConfirmCallback();
      }
    });
  }

  openManageGroupDialog(
    onConfirmCallback: () => void,
    onCancelCallback: () => void,
    data: {confirmDialogTitle: string; confirmDialogText?: string; deleteButtonTitle: string},
  ) {
    const dialogRef = this.dialog.open(ManageGroupConfirmDialogComponent, {
      width: '610px',
      data,
    });
    dialogRef.afterClosed().subscribe((result: {confirm: boolean}) => {
      result?.confirm ? onConfirmCallback() : onCancelCallback();
    });
  }

  showForbiddenDialog() {
    return this.dialog.open(ForbiddenAccessDialogComponent);
  }
}
